import Vue from 'vue';
import Modal from '../modal';

function modalBox(options) {
  const {
    type,
    title,
    content,
    confirmText,
    cancelText,
    onConfirm,
    opened,
    close,
    closed,
    cancelHidden
  } = options;

  const ModalBox = Vue.extend({
    render(h) {
      return h(Modal, {
        props: {
          type,
          title,
          confirmText,
          cancelText,
          cancelHidden,
          content,
          value: true
        },
        on: {
          confirm: onConfirm,
          open,
          opened,
          close,
          closed
        }
      });
    }
  });
  return new ModalBox().$mount();
}

export default modalBox;
